import { Button } from '@mui/material';
import { identityForgotPasswordStart } from '@redux/identity/identitySlice';
import { RootState } from '@redux/store';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

const ResetUserPassword = ({ email }: { email: string }) => {
 const dispatch = useDispatch();
 const { t } = useTranslation();
 const isForgotPasswordLoading = useSelector(
  (state: RootState) => !!state.identity.loading?.identityForgotPassword,
 );

 const handleSendForgotPasswordEmail = () => {
  if (!email) {
   return;
  }

  dispatch(
   identityForgotPasswordStart({
    Email: email,
   }),
  );
 };

 return (
  <Button
   variant="contained"
   onClick={handleSendForgotPasswordEmail}
   disabled={isForgotPasswordLoading}
   sx={{ width: '100%', mb: 2 }}
  >
   {t('user.sidebar.resetPassword.sendForgotPasswordEmail')}
  </Button>
 );
};

export default ResetUserPassword;
